<template>
    <div>
        <component-header
            title="Update Kyc"
            :hasSearch="false"
            :hasReload="false"
            :hasCreate="false"
            :hasback="true"
            @back-press="$router.push('/user')"
        />
        <b-card>
            <s-kyc
                v-if="documentList && currentUser"
                class="mt-2"
                ref="kycForm"
                @readKYC="KYCUpdate($event)"
                :kycData="documentList"
                :userID="currentUser._id"
            >
                <template v-slot:footer-button="data">
                    <b-row class="mt-3 justify-content-center">
                        <b-col md="2">
                            <b-button
                                class="btn btn-block"
                                btn-color="primary"
                                :disabled="
                                    !kycChangeObj.addressProofBack ||
                                    !kycChangeObj.addressProofFront ||
                                    !kycChangeObj.photoIdFront ||
                                    !kycChangeObj.photoIdBack ||
                                    !kycChangeObj.idproofNo ||
                                    !kycChangeObj.addressproofNo
                                "
                                @click="AgreeToNext(data.data)"
                                >Update KYC</b-button
                            >
                        </b-col>
                    </b-row>
                </template>
            </s-kyc>
        </b-card>
    </div>
</template>

<script>
import sKYC from "@/components/User/KYC_v2.vue";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "UpdateKyc",
    components: {
        "s-kyc": sKYC,
        ComponentHeader,
    },
    data() {
        return {
            currentUser: null,
            kycChangeObj: {},
            documentList: null,
            kycData: [],
        };
    },
    methods: {
        async AgreeToNext(item) {
            if (this.$route.query.mode === "update") {
                const idProofDoc = this.kycData.find(
                    (d) => d.category === "ID_PROOF",
                );
                const addProofDoc = this.kycData.find(
                    (d) => d.category === "ADDRESS_PROOF",
                );
                try {
                    if (idProofDoc) {
                        await this.$store.dispatch("tenant/updateKYCByTenant", {
                            data: {
                                documentNo: item.idproofNo,
                                docuementNo: item.idproofNo,
                                frontSideFilePath: item.photoIdFront,
                                backSideFilePath: item.photoIdBack,
                            },
                            userId: this.currentUser._id,
                            docId: idProofDoc._id || idProofDoc.id,
                        });
                    }
                    if (addProofDoc) {
                        await this.$store.dispatch("tenant/updateKYCByTenant", {
                            data: {
                                documentNo: item.addressproofNo,
                                docuementNo: item.addressproofNo,
                                frontSideFilePath: item.addressProofFront,
                                backSideFilePath: item.addressProofBack,
                            },
                            userId: this.currentUser._id,
                            docId: addProofDoc._id || addProofDoc.id,
                        });
                    }
                    await this.$store.dispatch("tenant/fetchKYCListByUser", {
                        id: this.currentUser._id,
                    });
                    this.documentList = {
                        ...this.documentList,
                        idproofNo: item.idproofNo,
                        addressproofNo: item.addressproofNo,
                        photoIdFront: item.photoIdFront,
                        photoIdBack: item.photoIdBack,
                        addressProofFront: item.addressProofFront,
                        addressProofBack: item.addressProofBack,
                    };
                    this.kycChangeObj = { ...item };
                    this.$swal({
                        title: "Success",
                        text: "KYC Updated Successfully!",
                        type: "success",
                    });
                    this.$router.push({
                        name: "EditUser",
                        params: {
                            id: this.currentUser._id,
                            userData: this.currentUser,
                        },
                    });
                } catch (error) {
                    this.$swal({
                        title: "Error",
                        text: "KYC update failed. Please try again.",
                        type: "error",
                    });
                }
            } else {
                this.$refs.kycForm
                    .submitKyc(this.currentUser._id)
                    .then((result) => {
                        this.$router.push({ path: "/user" });
                    })
                    .catch((error) => {});
            }
        },
        KYCUpdate(event) {
            this.kycChangeObj = event;
        },
    },
    mounted() {
        this.currentUser = this.$route.params.userData;
        const idData = this.$route.params.kycData;
        if (Array.isArray(idData)) {
            this.kycData = idData;
            const idProof = idData.find((x) => x.category === "ID_PROOF");
            const addProof = idData.find((x) => x.category === "ADDRESS_PROOF");
            if (idProof && addProof) {
                this.documentList = {
                    addressProofFront: addProof.frontSideFilePath,
                    addressProofBack: addProof.backSideFilePath,
                    photoIdFront: idProof.frontSideFilePath,
                    photoIdBack: idProof.backSideFilePath,
                    idproofNo: idProof.documentNo || idProof.docuementNo || "",
                    addressproofNo:
                        addProof.documentNo || addProof.docuementNo || "",
                };
            }
        }
    },
};
</script>
